import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22.948}
    height={25.989}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22199 25140"
    {...props}
  >
    <path
      d="M21382 139h-8176c-374 0-677 304-677 677v253H9127v1286H2118V1207H339v4521h1779v-963h2499v17551H1209c-589 0-1070 479-1070 1069v546c0 590 481 1070 1070 1070h8594c590 0 1069-480 1069-1070v-546c0-590-479-1069-1069-1069H6395V3339H4617v836H2118V2945h7009v829h3402v711c0 373 303 677 677 677h8176c373 0 677-304 677-677V816c0-373-304-677-677-677z"
      style={{
        fill: "#231f20",
        // stroke: "#fefefe",
        strokeWidth: 278.592,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
